"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@uirouter/angular");
const update_dap_dac_techone_facility_component_1 = require("./components/update-dap-dac-techone-facility.component");
exports.states = [
    {
        name: "updateDAPAndDACTechOneFacility",
        url: "/updateDAPAndDAC/update-dap-dac-techone-facility",
        component: update_dap_dac_techone_facility_component_1.UpdateDAPAndDACTechOneFacilityComponent
    }
];
